import { render, staticRenderFns } from "./FacilityAreaAndLocationOld.vue?vue&type=template&id=0e5bde64&scoped=true"
import script from "./FacilityAreaAndLocationOld.vue?vue&type=script&lang=js"
export * from "./FacilityAreaAndLocationOld.vue?vue&type=script&lang=js"
import style0 from "./FacilityAreaAndLocationOld.vue?vue&type=style&index=0&id=0e5bde64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5bde64",
  null
  
)

export default component.exports